import { useEffect, useState } from 'react';
import useSnack from 'hooks/useSnack';
import moment from 'moment';

const IDLE_TIME = 5 * 60 * 1000; // 5 min
const MAX_TIME = 90 * 60 * 1000; // 90 min
const WARN_TIME = 75 * 60; // 75 min
let roomMaxTimer = null;
let idleTimer = null;
let durationInterval = null;

export default (room, participants) => {
  const [duration, setDuration] = useState(0);
  const [startTime, setStartTime] = useState();
  const snack = useSnack();

  useEffect(() => {
    if (room) {
      setStartTime(moment());
      roomMaxTimer = setTimeout(() => {
        room.disconnect();
      }, MAX_TIME);
      durationInterval = setInterval(() => {
        setDuration((prev) => prev + 1);
      }, 5000);
    } else {
      setDuration(0);
      setStartTime();
      cleanup();
    }
  }, [room]);

  useEffect(() => {
    if (participants.length) {
      clearTimeout(idleTimer);
    } else if (room) {
      idleTimer = setTimeout(() => {
        snack.error(
          'Session ended as no other participants joined.',
          null,
          null,
          {
            autoHideDuration: 0,
          },
        );
        room.disconnect();
      }, IDLE_TIME);
    }
  }, [participants, room]);

  useEffect(() => {
    return cleanup;
  }, []);

  useEffect(() => {
    if (duration === WARN_TIME) {
      const left = (MAX_TIME / 1000 - duration) / 60;
      snack.warning(`Session will end in ${left} minutes.`, null, null, {
        autoHideDuration: 0,
      });
    }
  }, [duration]);

  function cleanup() {
    clearTimeout(idleTimer);
    clearTimeout(roomMaxTimer);
    clearInterval(durationInterval);
  }
  return {
    duration,
  };
};
